import { FC } from "react";
import { useNavigator } from "../../lib/Hooks";
import { ClearSearchButton } from "../Filters";
import { FilterPublishedImports } from "../common/FilterPublishedArtifacts";
import { IExport, IImport, IPropertiesProps } from "./types";

import { Grid, styled } from "@mui/material";
import { SpanHoverLink } from "../ui/common";

const FilterForm = styled("form")`
  padding-top: 10px;
`;

const Properties = ({ descriptors, names }: IPropertiesProps) => {
  const properties = Object.assign({}, ...descriptors);
  return (
    <>
      {names
        .filter((name) => properties[name])
        .map((name) => {
          return (
            <div key={name}>
              {name}: {properties[name]}
            </div>
          );
        })}
    </>
  );
};

const Import: FC<IImport> = ({ bundle, table }) => {
  const navigator = useNavigator();
  return (
    <>
      <b>{table.name}</b>
      <br />
      <SpanHoverLink
        onClick={() =>
          navigator.gotoDeclaration({
            changelist_id: table.changelist_id as string,
            project: table.project,
            line: table.line as number,
          })
        }
      >
        "{table.project}":{table.line}
      </SpanHoverLink>
      <div>type: {bundle.import_type}</div>
      <Properties
        descriptors={[bundle.descriptor, table.descriptor, table.parameters]}
        names={["network", "pattern", "regex"]}
      />
    </>
  );
};

const Export: FC<IExport> = ({ table }) => {
  const navigator = useNavigator();
  return (
    <>
      <b>{table.name}</b>
      <br />
      <SpanHoverLink
        onClick={() =>
          navigator.gotoDeclaration({
            changelist_id: table.changelist_id as string,
            project: table.project,
            line: table.line as number,
          })
        }
      >
        "{table.project}":{table.line}
      </SpanHoverLink>
      <br />
      type: {table.export_type || " - "}
      <br />
      truncate: {table.descriptor?.truncate ? "true" : "false"}
      <br />
      bigquery://{table.descriptor?.project}:{table.descriptor?.dataset}.{table.descriptor?.table}
      <br />
      <br />
    </>
  );
};

type SourceFiltersProps = {
  importName: string | null;
  project: string;
  onChange: (value: { importName: string | null; project: string }) => void;
};

const SourceFilters: FC<SourceFiltersProps> = ({ importName = "", project = "", onChange }) => {
  const onClearFilters = () => {
    onChange({ importName: "", project: "" });
  };

  return (
    <FilterForm>
      <Grid container direction="row">
        <Grid>
          <FilterPublishedImports
            id="uploadsImportSelect"
            projectName={project}
            importName={importName}
            onChange={(value) => onChange({ importName: value.importName ?? null, project: value.project ?? "" })}
            allowSelectProjects={true}
            allowSelectSuspended={true}
          />
        </Grid>
        <Grid sx={{ alignItems: "flex-end", height: "56px", display: "flex" }}>
          <ClearSearchButton onClear={onClearFilters} />
        </Grid>
      </Grid>
    </FilterForm>
  );
};

export { Export, Import, Properties, SourceFilters };
